import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import DataTable from "@/admin/DataTable";
import { useFetch, PageHeader, Badge, PAY_STATUS, Progress, Loading, ErrorBox, fmtDate } from "@/admin/ui";

const COLUMNS = [
  { key: "name", label: "Nombre", render: (r) => <b>{r.name}</b> },
  { key: "email", label: "Email", render: (r) => <span className="adm-sub" style={{ fontSize: 13 }}>{r.email}</span> },
  { key: "created_at", label: "Fecha alta", render: (r) => fmtDate(r.created_at) },
  { key: "pay_status", label: "Estado pago", render: (r) => <Badge map={PAY_STATUS} value={r.pay_status} testid={`admin-student-status-${r.id}`} /> },
  { key: "progress", label: "Progreso", render: (r) => <Progress value={r.progress} /> },
  { key: "last_seen", label: "Último acceso", render: (r) => <span className="adm-sub">{fmtDate(r.last_seen, true)}</span> },
  { key: "act", label: "", render: (r) => <Link to={`/admin/alumnos/${r.id}`} className="adm-btn sm" data-testid={`admin-student-view-${r.id}`}>Ver ficha</Link> },
];

export default function AdminStudents() {
  const { data, error } = useFetch("/admin/students");
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("all");
  const students = useMemo(() => (data || []).filter((s) => s.role !== "admin"), [data]);
  const rows = useMemo(() => students.filter((s) =>
    (status === "all" || s.pay_status === status) &&
    (`${s.name} ${s.email}`.toLowerCase().includes(q.trim().toLowerCase()))), [students, q, status]);
  if (error) return <ErrorBox />;
  if (!data) return <Loading />;
  return (
    <div data-testid="admin-students">
      <PageHeader title="Alumnos" subtitle={`${students.length} alumnos registrados`} />
      <div className="adm-row" style={{ marginBottom: "1rem" }}>
        <div style={{ position: "relative", flex: "1 1 260px", maxWidth: 380 }}>
          <Search size={15} style={{ position: "absolute", left: 11, top: 12, color: "#718096" }} />
          <input className="adm-input" style={{ paddingLeft: 32 }} placeholder="Buscar por nombre o email" value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-students-search" />
        </div>
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-[190px] bg-white" data-testid="admin-students-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los estados</SelectItem>
            {Object.entries(PAY_STATUS).map(([k, [l]]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <DataTable columns={COLUMNS} rows={rows} testid="admin-students-table" />
    </div>
  );
}
